import { SET_FEATURES } from "./constants";
import { isWindowDefined } from "@src/helpers/url";

export const setFeatures = features => ({
  type: SET_FEATURES,
  payload: features
});

export const setGlobalFeatureName = testName => {
  if (isWindowDefined()) {
    window.mvtTestName = testName;
  }
};
